var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.twilioStatus === null
        ? _c("div", { staticClass: "blocks" }, [
            _c(
              "div",
              {
                staticClass:
                  "pt-3 l-m-b-20 align-items-center d-flex justify-content-between"
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("h1", { staticClass: "w-full" }, [
                    _vm._v("Phone numbers")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group search" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn input-group-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSearch }
                      },
                      [
                        _c("i", {
                          class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.q,
                          expression: "q"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Search" },
                      domProps: { value: _vm.q },
                      on: {
                        keyup: function($event) {
                          _vm.searchText($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.q = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            )
          ])
        : _vm.twilioStatus === "active"
          ? _c("div", { staticClass: "blocks" }, [
              _c(
                "div",
                {
                  staticClass:
                    "pt-3 l-m-b-20 align-items-center d-flex justify-content-between"
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("h1", { staticClass: "w-full" }, [
                      _vm._v("Phone numbers")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group search" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn input-group-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.clearSearch }
                        },
                        [
                          _c("i", {
                            class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.q,
                            expression: "q"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Search" },
                        domProps: { value: _vm.q },
                        on: {
                          keyup: function($event) {
                            _vm.searchText($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.q = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right d-flex new-twil" }, [
                    _vm.$_can("twilio-subaccount.suspend") ||
                    _vm.$_can("twilio-subaccount.close")
                      ? _c(
                          "div",
                          { staticClass: "dropdown dropdown-menu-right pr-3" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                                attrs: {
                                  "aria-labelledby": "dropdownMenuButton"
                                }
                              },
                              [
                                _vm.$_can("twilio-subaccount.suspend")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dropdown-box border-bottom pointer",
                                        on: { click: _vm.suspendTwilioAccount }
                                      },
                                      [
                                        _c(
                                          "button",
                                          { staticClass: "dropdown-item" },
                                          [
                                            _vm._v(
                                              "\n                Suspend Twillio\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "You can enable it any time and continue using phone numbers you've already purchased"
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_can("twilio-subaccount.close")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-box pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.closeTwilio = true
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          { staticClass: "dropdown-item" },
                                          [
                                            _vm._v(
                                              "\n                Close Twillio\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                You will no longer be able to use services provided from twilio, your account will be suspended for\n                the time being\n              "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("phone-numbers.store")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                _vm.showCreateModal = true
                              }
                            }
                          },
                          [_vm._v("\n          ADD PHONE NUMBER\n        ")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ])
          : _c("div", { staticClass: "blocks" }, [
              _vm.$_can("twilio-subaccount.store")
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "row py-3 l-m-b-20 mx-1 bg-light" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 py-2 border-left" },
                          [
                            _c("p", [
                              _vm._v(
                                "\n            We’re obsessed with the security of customer data. I’d bet you are too. One of the most commonly\n            requested\n            features from customers delivering sensitive information via SMS is the ability to redact the message\n            bodies\n            before they’re stored.\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n            We’re thrilled to announce Message Body Redaction for Programmable SMS is now available in Developer\n            Preview.\n            With this new feature, developers can take even more control over the privacy of their customers’ data.\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.twilioStatus === "suspended"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mb-2",
                                    on: { click: _vm.enableTwilioAccount }
                                  },
                                  [
                                    _vm._v(
                                      "\n            Reactivate twilio\n          "
                                    )
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mb-2",
                                    on: { click: _vm.createTwilioAccount }
                                  },
                                  [_vm._v("Enable twilio")]
                                ),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "twilio" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _c("div", [_vm._m(2)])
            ]),
      _vm._v(" "),
      !_vm.phoneNumbers
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _vm.twilioStatus === "active" && _vm.$_can("phone-numbers.index")
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "blocks" },
                    _vm._l(_vm.phoneNumbers, function(phone, index) {
                      return _c("SettingsPhoneNumbersBlock", {
                        key: index,
                        attrs: { phone: phone },
                        on: {
                          "update:phone": function($event) {
                            phone = $event
                          },
                          openEditModal: function($event) {
                            _vm.openEditModal(phone)
                          }
                        }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row blocks" },
                    [
                      _vm.meta.total
                        ? _c(
                            "div",
                            { staticClass: "col-md-6 mb-1 text-black-50 pl-0" },
                            [
                              _vm._v(
                                "\n          Showing " +
                                  _vm._s(_vm.meta.from) +
                                  " - " +
                                  _vm._s(_vm.meta.to) +
                                  " of " +
                                  _vm._s(_vm.meta.total) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("pagination", {
                        staticClass: "col-md-6 mb-1 pr-0",
                        attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
      _vm._v(" "),
      _vm.showCreateModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Choose A Phone Number")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("p", [
                    _vm._v(
                      "\n        You can get a phone number for your company that will allow you to send and receive messages. Mod24 will\n        cover the expenses.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.step === 1
                    ? [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("p", [
                              _vm._v(
                                "Enter the location or area code in which you want to find a phone number."
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-4" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "select-wrap" },
                              [
                                _c("label", [_vm._v("Filter by")]),
                                _vm._v(" "),
                                _c("simple-select", {
                                  attrs: {
                                    options: _vm.filterOptions,
                                    placeholder: "Select"
                                  },
                                  model: {
                                    value: _vm.filterBy,
                                    callback: function($$v) {
                                      _vm.filterBy = $$v
                                    },
                                    expression: "filterBy"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("div", { staticClass: "select-wrap" }, [
                                _c("label", [_vm._v("Value")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.value,
                                      expression: "value"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.value },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.value = $event.target.value
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("error-field", {
                                attrs: { errors: _vm.errors, field: "value" }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row m-0" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary pull-right ld-ext-right",
                                class: _vm.loadingButton ? "running" : "",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.buttonDisabled
                                },
                                on: { click: _vm.find }
                              },
                              [
                                _vm._v(
                                  "\n              Search\n              "
                                ),
                                _c("div", { staticClass: "ld ld-ball ld-flip" })
                              ]
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mb-2",
                            on: {
                              click: function($event) {
                                _vm.step = 1
                              }
                            }
                          },
                          [_vm._v("Go back")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "phone-number-modal" }, [
                          _c(
                            "table",
                            {
                              staticClass: "table m-table table-hover",
                              staticStyle: {
                                "max-height": "80vh",
                                overflow: "auto"
                              }
                            },
                            [
                              _c("thead", [
                                _c("tr", { staticClass: "m-table__heading" }, [
                                  _c("th", [_vm._v("Phone number")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Location")])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.availablePhones, function(phone) {
                                  return _c(
                                    "tr",
                                    {
                                      key: phone.id,
                                      on: {
                                        click: function($event) {
                                          _vm.selectNumber(phone)
                                        }
                                      }
                                    },
                                    [
                                      _c("td", [
                                        _vm._v(_vm._s(phone.friendlyName))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(phone.region) +
                                            ", " +
                                            _vm._s(phone.locality)
                                        )
                                      ])
                                    ]
                                  )
                                })
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 3
                    ? [
                        _c("div", { staticClass: "mb-2" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.phone.friendlyName) +
                                " -\n            " +
                                _vm._s(_vm.phone.region) +
                                ", " +
                                _vm._s(_vm.phone.locality) +
                                "\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row no-gutters" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.step = 2
                                  }
                                }
                              },
                              [_vm._v("Go back to search results")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.save(_vm.phone)
                                  }
                                }
                              },
                              [_vm._v("Get this phone")]
                            )
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                !_vm.editPhone.type || _vm.editPhone.type.id === ""
                  ? _c("h4", [_vm._v("Select type")])
                  : _vm.editPhone.type.id === 1
                    ? _c("h4", [_vm._v("Select type and company")])
                    : _vm.editPhone.type.id === 2
                      ? _c("h4", [_vm._v("Select type and carrier")])
                      : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col pr-1" }, [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Phone")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-control" }, [
                        _vm._v(
                          _vm._s(
                            _vm.phoneMask.maskedPhone(
                              _vm.editPhone.phone_number
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col pl-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "select-wrap" },
                        [
                          _c("label", [_vm._v("Type")]),
                          _vm._v(" "),
                          _c("simple-select", {
                            attrs: {
                              options: _vm.phoneTypeOptions,
                              placeholder: "Select"
                            },
                            model: {
                              value: _vm.editPhone.type.id,
                              callback: function($$v) {
                                _vm.$set(_vm.editPhone.type, "id", $$v)
                              },
                              expression: "editPhone.type.id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "type_id" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.editPhone.type.id === 1
                    ? _c(
                        "div",
                        { staticClass: "col px-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-wrap" },
                            [
                              _c("label", [_vm._v("Company")]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.companies,
                                  placeholder: "Select"
                                },
                                model: {
                                  value: _vm.editPhone.company.id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editPhone.company, "id", $$v)
                                  },
                                  expression: "editPhone.company.id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "company_id" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editPhone.type.id === 2
                    ? _c(
                        "div",
                        { staticClass: "col px-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-wrap" },
                            [
                              _c("label", [_vm._v("Carrier")]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.carriers,
                                  placeholder: "Select"
                                },
                                model: {
                                  value: _vm.editPhone.carrier.id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editPhone.carrier, "id", $$v)
                                  },
                                  expression: "editPhone.carrier.id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "carrier_id" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col text-right" }, [
                    _vm.$_can("phone-numbers.destroy")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            on: { click: _vm.deleteNumber }
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("phone-numbers.store")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.edit }
                          },
                          [_vm._v("Save")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.closeTwilio
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Close Twilio")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("p", [
                      _vm._v(
                        "\n            You will no longer be able to use services provided from twilio, your account will be suspended for the\n            time being\n          "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: { click: _vm.closeModal }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.closeTwilioAccount }
                      },
                      [_vm._v("Close Twilio")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-select twilio-btn",
        attrs: {
          type: "button",
          id: "dropdownMenuButton",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "twilio-logo-red",
          attrs: { src: require("../../assets/img/twilio-logo-red.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 py-2 text-right icon-twilio" }, [
      _c("div", { staticClass: "icon-wrap" }, [
        _c("span", { staticClass: "mod-icon-twillio-red" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row py-3 l-m-b-20 mx-1 bg-light" }, [
      _c("div", { staticClass: "col-2 py-2 text-right icon-twilio" }, [
        _c("div", { staticClass: "icon-wrap" }, [
          _c("span", { staticClass: "mod-icon-twillio-red" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 py-2 border-left" }, [
        _c("p", [
          _vm._v(
            "\n            Twilio subaccount is managed by your cluster administrator, it was suspended or wasn’t created yet.\n            Please contact them for further inquires.\n          "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77b1ac2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b1ac2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SettingsPhoneNumbers.vue
// module id = null
// module chunks = 